import { Button, Card, CardContent, Input, Label } from "@exhousing/design-system";
import { Plus } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { AccountDrawer } from "@/components/crm/AccountDrawer";
import { useAccounts, useCreateAccount } from "@/hooks/api/useCrm";

export function AccountsTable() {
  const { data: accounts } = useAccounts();
  const create = useCreateAccount();
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button size="sm" onClick={() => setShowForm((s) => !s)}>
          <Plus className="size-4" />
          New account
        </Button>
      </div>
      {showForm && (
        <Card>
          <CardContent className="pt-6">
            <form
              className="flex flex-wrap items-end gap-3"
              onSubmit={(e) => {
                e.preventDefault();
                if (!name) return;
                create.mutate(
                  { name, city: city || null },
                  {
                    onSuccess: () => {
                      toast.success("Account created");
                      setName("");
                      setCity("");
                      setShowForm(false);
                    },
                    onError: (err) => toast.error(err.message),
                  },
                );
              }}
            >
              <div className="space-y-1.5">
                <Label htmlFor="acc-name">Company name</Label>
                <Input id="acc-name" value={name} onChange={(e) => setName(e.target.value)} />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="acc-city">City</Label>
                <Input id="acc-city" value={city} onChange={(e) => setCity(e.target.value)} />
              </div>
              <Button type="submit" size="sm">Create</Button>
            </form>
          </CardContent>
        </Card>
      )}
      <Card>
        <CardContent className="p-0">
          {accounts && accounts.length > 0 ? (
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-border text-left text-xs uppercase tracking-wide text-muted-foreground">
                  <th className="px-6 py-3 font-medium">Account</th>
                  <th className="px-6 py-3 font-medium">City</th>
                  <th className="px-6 py-3 font-medium">Email</th>
                </tr>
              </thead>
              <tbody>
                {accounts.map((a) => (
                  <tr
                    key={a.id}
                    onClick={() => setSelected(a.id)}
                    className="cursor-pointer border-b border-border/60 transition-colors last:border-0 hover:bg-muted/50"
                  >
                    <td className="px-6 py-3 font-medium">{a.name}</td>
                    <td className="px-6 py-3 text-muted-foreground">{a.city ?? "—"}</td>
                    <td className="px-6 py-3 text-muted-foreground">{a.email ?? "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="py-12 text-center text-sm text-muted-foreground">No accounts yet.</p>
          )}
        </CardContent>
      </Card>

      <AccountDrawer accountId={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
